var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.949,
    height: 26.064,
    viewBox: "0 0 25.949 26.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_55",
    "data-name": "Trazado 55",
    d: "M124,121.5h25.949v26.064H124Zm0,0",
    transform: "translate(-124 -121.5)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Disen\\u0303o_sin_ti\\u0301tulo-3",
    "data-name": "Disen\\u0303o sin ti\\u0301tulo-3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_54",
    "data-name": "Trazado 54",
    d: "M146.49,125.292a12.792,12.792,0,0,0-9.136-3.792,12.923,12.923,0,0,0-11.195,19.365l-1.824,6.7,6.842-1.8a12.916,12.916,0,0,0,15.313-20.473Zm-9.136,19.86a10.767,10.767,0,0,1-5.473-1.5l-.391-.234-4.066,1.069,1.082-3.962-.261-.4a10.739,10.739,0,0,1,9.1-16.446,10.738,10.738,0,0,1,.013,21.476Zm5.891-8.027c-.326-.156-1.916-.938-2.2-1.056s-.508-.156-.73.156-.834,1.056-1.017,1.264-.378.248-.7.078a8.68,8.68,0,0,1-2.593-1.6,9.856,9.856,0,0,1-1.8-2.241c-.182-.326-.026-.5.143-.665.143-.143.326-.378.482-.56a2.26,2.26,0,0,0,.326-.534.6.6,0,0,0-.026-.56c-.078-.156-.73-1.746-.99-2.4-.261-.626-.534-.547-.73-.56h-.626a1.17,1.17,0,0,0-.86.4,3.676,3.676,0,0,0-1.121,2.7,6.278,6.278,0,0,0,1.316,3.336,14.307,14.307,0,0,0,5.512,4.874,15.768,15.768,0,0,0,1.837.678,4.466,4.466,0,0,0,2.033.13,3.282,3.282,0,0,0,2.176-1.538,2.547,2.547,0,0,0,.182-1.538C143.767,137.347,143.571,137.282,143.245,137.125Zm0,0",
    transform: "translate(-124.32 -121.5)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhats);
export default __webpack_public_path__ + "static/media/whats.56ef1a36b2d18237d7be831828434660.svg";
export { ForwardRef as ReactComponent };